const userStorageName = 'USER_INFO';
const authorizationStorageName = 'AUTHORIZATION';
const menuName = 'MENU_LIST';

// token
export function getToken() {
	return JSON.parse(localStorage.getItem(authorizationStorageName))
}
export function setToken(value) {
	localStorage.setItem(authorizationStorageName, JSON.stringify(value))
}
export function removeToken(value) {
	localStorage.removeItem(authorizationStorageName)
}
// 用户信息
export function getUserInfo() {
	return JSON.parse(localStorage.getItem(userStorageName))
}
export function setUserInfo(value) {
	localStorage.setItem(userStorageName, JSON.stringify(value))
}
export function removeUserInfo(value) {
	localStorage.setItem(userStorageName, JSON.stringify(value))
}
// 用户菜单
export function getMenu() {
	return JSON.parse(localStorage.getItem(menuName))
}
export function setMenu(value) {
	localStorage.setItem(menuName, JSON.stringify(value))
}
export function removeMenu(value) {
	localStorage.setItem(menuName, JSON.stringify(value))
}



// WEBPACK FOOTER //
// ./src/libs/storage.js